export default function loadImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image()

    image.onload = () => {
      resolve(image)
    }

    image.onerror = (e) => {
      reject(e)
    }

    image.src = url
  })
}
